import MarketingReferenceCard from './MarketingReferenceCard';

export default MarketingReferenceCard;
